import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../util/request';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { userInfo, updateUserInfoFun } from '../../redux/slice';
import { Pagination, Tooltip } from 'antd';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { SortTypeSelect, DatePickerField } from '../../components/common/form';
import { Image } from '../../assets';

import './index.scss';
import { isLabelWithInternallyDisabledControl } from '@testing-library/user-event/dist/utils';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Loading from '../../components/common/loading';
import SelectedFilters from '../../components/page/selected-filters/selected-filters';

const SelectRole = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(userInfo);
  const { t, i18n } = useTranslation();
  const filterBoxRef = useRef(null);
  const [searchhandle, setSearchHandle] = useState(true);
  const [listData, setListData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const [isSearchable, setIsSearchable] = useState(false);
  const [sortType, setSortType] = useState({ value: 'ascClientName', label: t('Sort_name_az'), sortWay: 'asc' },);
  const [searchDocType, setsearchDocType] = useState(null);
  const [searchProjectCode, setSearchProjectCode] = useState(null);
  const [searchlang, setSearchlang] = useState(null);
  const [region, setRegion] = useState(null);
  const [searchMasterPlanIds, setSearchMasterPlanIds] = useState(null);

  const [searchName, setSearchName] = useState(null);
  const [searchClientId, setsearchClientId] = useState(null);

  const [projectCodeOption, setProjectCodeOption] = useState([]);
  const [masterPlanOption, setMasterPlanOption] = useState([]);
  const [regionOption, setRegionOption] = useState([]);
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [loading, setLoading] = useState(false)
  const sortOption = [
    { value: 'ascClientName', label: t('Sort_name_az'), sortWay: 'asc' },
    { value: 'descClientName', label: t('Sort_name_za'), sortWay: 'desc' },
    { value: 'ascClientIDClientID', label: t('Sort_id_az'), sortWay: 'asc' },
    { value: 'desClientID', label: t('Sort_id_za'), sortWay: 'desc' },
  ];
  // const [sortType, setSortType] = useState(sortOption[0]);

  // const regionOption = [
  //   { value: 'CN', label: 'CN' },
  //   { value: 'DB', label: 'DB' },
  //   { value: 'HK', label: 'HK' },
  //   { value: 'TW', label: 'TW' },
  //   { value: 'ID', label: 'ID' },
  //   { value: 'JP', label: 'JP' },
  //   { value: 'MY', label: 'MY' },
  //   { value: 'SG', label: 'SG' },
  // ];
  const [LangOption, setLangOption] = useState([]);
  const [filterData, setFilterData] = useState({});
  const handleMouseEnterFilterBox = () => {
    setShowFilterBox((prevState) => !prevState);
  };
  const init = async (searchPageNum) => {
    let projectCode =
      searchProjectCode && searchProjectCode.length > 0
        ? searchProjectCode.map((obj) => obj.value).toString()
        : null;
    let searchRegion =
      region && region.length > 0 ? region.map((obj) => obj.value).toString() : null;
    let lang =
      searchlang && searchlang.length > 0 ? searchlang.map((obj) => obj.value).toString() : null;
    let masterPlanIds =
      searchMasterPlanIds && searchMasterPlanIds.length > 0
        ? searchMasterPlanIds.map((obj) => obj.value).toString()
        : null;
    //console.log(projectCode);
    let params = {
      clientId: searchClientId,
      name: searchName,
      offset: 'ASC',
      size: pageSize,
      page: searchPageNum === 0 ? 0 : pageNum,
      userId: user.userId,
      deviceId: null,
      deviceModel: ' WEB',
      projectCodes: projectCode,
      region: searchRegion,
      primaryLanguage: lang,
      masterPlanIds: masterPlanIds,
      deviceToken: null,
      entry: 'WEB',
      isChina: false,
      accessToken: user.accessToken,
      userId: user.userId,
      sort: (sortType.value == 'ascClientName' || sortType.value == 'descClientName') ? 'ClientName,' + sortType.sortWay : 'ClientID,' + sortType.sortWay,
    };
    const data = await get('/businessPartner/clients', params);
    if (data) {
      data.content?.map((item, index) => {
        data.content[index].show = true;
      });
      setListData(data.content);
      setTotal(data.totalElements);
    }
    // 关掉Filter Box
    setShowFilterBox(false);
  };

  const handleSearchName = (e) => {
    setSearchName(e.target.value);
  };

  const handleClear = () => {
    setSearchName('');
    setsearchClientId('');
    setSearchHandle(!searchhandle);
  };
  // const getProjectOption = async () => {
  //   let params = {
  //     accessToken: user.accessToken,
  //     userId: user.userId,
  //   };
  //   const data = await get('/appProducts/', params);
  //   if (data) {
  //     let option = [];
  //     let masterOption = [];
  //     data?.map((item) => {
  //       option.push({ value: item.productNumber, label: item.productName });
  //       masterOption.push({ value: item.masterPlanID, label: item.masterPlanName });
  //     });

  //     let uniqueMasterOption = masterOption.filter((item, index, self) => {
  //       return self.findIndex((t) => t.value === item.value) === index;
  //     });

  //     setProjectCodeOption(option);
  //     setMasterPlanOption(uniqueMasterOption);
  //   }
  // };
  const getRegionOption = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/businessPartner/clients/region', params);
    if (data) {
      let option = [];
      data?.map((item) => {
        option.push({ value: item.code, label: item.name });
      });
      setRegionOption(option);
    }
  }
  const getProjectOption = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/businessPartner/clients/project', params);
    if (data) {
      let option = [];
      data?.map((item) => {
        option.push({ value: item.code, label: item.nameEn });
      });
      setProjectCodeOption(option);
    }
  }
  const getMasterPlanOption = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/businessPartner/clients/masterPlan', params);
    if (data) {
      let option = [];
      data?.map((item) => {
        option.push({ value: item.code, label: item.nameEn });
      });
      setMasterPlanOption(option);
    }
  }

  const goDetail = (id, name) => {
    history.push({
      pathname: '/Investments/' + id + '/' + name,
    });
  };
  const getLangOption = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/option/primaryLanguage', params);
    if (data) {
      let option = [];
      data?.payload?.map((item) => {
        option.push({ value: item.code, label: item.name });
      });
      setLangOption(option);
    }
  };

  const applyFilter = () => {
    setFilterData({ 'searchProjectCode': searchProjectCode, 'region': region, 'searchlang': searchlang, 'searchMasterPlanIds': searchMasterPlanIds })
    init();
  }

  const resetFilter = function () {
    setSearchProjectCode(null);
    setRegion(null);
    setSearchlang(null);
    setSearchMasterPlanIds(null);
    setSearchHandle(!searchhandle);
    setFilterData({})
  }

  const [isRemoveTagCalled, setIsRemoveTagCalled] = useState(false);

  useEffect(() => {

    if (isRemoveTagCalled) {
      applyFilter()
      setIsRemoveTagCalled(false);
    }
  }, [searchProjectCode, region, searchlang, searchMasterPlanIds])

  const removeFilter = function (label, id) {
    setIsRemoveTagCalled(true)

    let newList = []
    switch (label) {
      case 'searchProjectCode':
        newList = searchProjectCode.filter((item) => item.value !== id);
        setSearchProjectCode(newList)
        break;
      case 'region':
        if (region != null) {
          newList = region.filter((item) => item.value !== id);
          setRegion(newList)
        }
        break;
      case 'searchlang':
        if (searchlang != null) {
          newList = searchlang.filter((item) => item.value !== id);
          setSearchlang(newList)
        }
        break;
      case 'searchMasterPlanIds':
        if (searchMasterPlanIds != null) {
          newList = searchMasterPlanIds.filter((item) => item.value !== id);
          setSearchMasterPlanIds(newList)
        }
        break;
      default:
        break;
    }
  }

  const downloadFile = async (apiUrl, fileName, clientID) => {
    setLoading(true)
    axios.get(process.env.REACT_APP_BASEPATH + apiUrl, {
      responseType: 'blob',
      headers: {
        accessToken: user.accessToken,
        userId: user.userId,
        clientID: clientID
      }
    }).then((res) => {
      if (res.data.size === 0) { return }
      setLoading(false)
      const blob = new Blob([res.data], {
        type: 'application/pdf'
      })
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement('a'); // 创建a标签
      link.href = objectUrl;
      link.download = fileName;
      link.click(); // 下载文件
      URL.revokeObjectURL(objectUrl);

    }).catch((err) => {
      console.log('---err---', err)
    })
  }

  useEffect(() => {
    init();
    getProjectOption();
    getLangOption();
    getRegionOption()
    getMasterPlanOption()
  }, []);
  useEffect(() => {
    init();
  }, [pageNum, pageSize]);
  useEffect(() => {
    init();
  }, [searchhandle]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
        setShowFilterBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterBox]);

  // sort默认值多语言切换
  useEffect(() => {
    // 添加一个监听器，当语言变化时更新label
    const handleLanguageChange = () => {
      setSortType(prevSortType => ({
        ...prevSortType,
        label: i18n.t('Sort_name_az')
      }));
    };

    // 监听语言变化
    i18n.on('languageChanged', handleLanguageChange);

    // 清理函数，移除监听器
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n])


  return (
    <>
      {
        user.sfUserType !== 'IR' && (<>
          <div className="viewClient">
            {loading ? <Loading /> : null}
            <div className="main-box">
              <div className="headline viewclient-wrapper">
                <div className='col-md-4 viewclient-title'><p>{t('View Clients')}</p></div>
                <div className='col-md-8 viewclient-header'></div>
              </div>
              <div className="submit-box">
                <div className=" float-left searchClientControl">
                  <input
                    className="form-control"
                    type="text"
                    placeholder={t("Client Name")}
                    aria-label="search input"
                    value={searchName}
                    onChange={handleSearchName}
                  ></input>
                </div>
                <div className=" float-left searchClientControl">
                  <input
                    className="form-control"
                    type="text"
                    placeholder={t("Client ID")}
                    aria-label="search input"
                    value={searchClientId}
                    onChange={(e) => {
                      setsearchClientId(e.target.value);
                    }}
                  ></input>
                </div>
                <div className=" float-left ">
                  <div className='filter-search-buttons'>
                    <button
                      type="button"
                      className="searchBtn btn btn-outline-theme"
                      onClick={() => {
                        init(0);
                      }}
                    >
                      {t('Search')}
                    </button>
                    <button
                      type="button"
                      className="linkBtn btn btn-link-theme "
                      onClick={() => {
                        handleClear();
                      }}
                    >
                      {t('Clear')}
                    </button>
                  </div>
                </div>
                <div className=" float-right ">
                  <div className="filterSortby">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 22"
                      fill="none"
                    >
                      <path
                        d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z"
                        fill="#003448"
                      />
                    </svg>
                    <div>
                      <button type="button" className="hoverFilter linkBtn btn btn-link-theme" onClick={handleMouseEnterFilterBox}>
                        {t('Filter')}
                      </button>
                      {showFilterBox ?
                        <div className="notification filter-box" ref={filterBoxRef}>
                          <div className="arrows"></div>
                          <div className="doc-noumenon">
                            <div className="field-group">
                              {t('Project')}
                              <Select
                                placeholder={t('All')}
                                isMulti
                                isSearchable={true}
                                options={projectCodeOption}
                                value={searchProjectCode}
                                onChange={(data) => {
                                  setSearchProjectCode(data);
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#F5F7FA',
                                    primary: '#003448',
                                  },
                                })}
                              />
                            </div>
                            <div className="field-group">
                              {t('Region')}
                              <Select
                                placeholder={t('All')}
                                isMulti
                                isSearchable={isSearchable}
                                options={regionOption}
                                value={region}
                                onChange={(data) => {
                                  setRegion(data);
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#F5F7FA',
                                    primary: '#003448',
                                  },
                                })}
                              />
                            </div>
                            <div className="field-group">
                              {t('Language')}
                              <Select
                                isMulti
                                placeholder={t('All')}
                                isSearchable={isSearchable}
                                options={LangOption}
                                value={searchlang}
                                onChange={(data) => {
                                  setSearchlang(data);
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#F5F7FA',
                                    primary: '#003448',
                                  },
                                })}
                              />
                            </div>
                            <div className="field-group">
                              {t('Master Plan')}
                              <Select
                                isMulti
                                placeholder={t('All')}
                                isSearchable={true}
                                options={masterPlanOption}
                                value={searchMasterPlanIds}
                                onChange={(data) => {
                                  setSearchMasterPlanIds(data);
                                }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#F5F7FA',
                                    primary: '#003448',
                                  },
                                })}
                              />
                            </div>

                            <div className="btn-box">
                              <button
                                type="button"
                                style={{ float: 'right' }}
                                className="ApplyBtn btn btn-outline-next"
                                onClick={applyFilter}
                              >
                                {t('Apply')}
                              </button>
                              <button
                                type="button"
                                style={{ float: 'right' }}
                                className="ResetBtn btn btn-outline-theme"
                                onClick={() => {
                                  setSearchProjectCode(null);
                                  setRegion(null);
                                  setSearchlang(null);
                                  setSearchMasterPlanIds(null);
                                  setSearchHandle(!searchhandle);
                                }}
                              >
                                {t('Reset')}
                              </button>
                            </div>
                          </div>
                        </div>
                        : null
                      }
                    </div>

                    <div className="fly-mid"></div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.35766 16.7616H10.0979C10.1826 16.7616 10.252 16.7888 10.3064 16.843C10.3606 16.8977 10.3879 16.967 10.3879 17.052C10.3879 17.1241 10.3578 17.1969 10.2972 17.2692L7.40594 20.1606C7.34556 20.2148 7.27601 20.2419 7.19747 20.2419C7.12489 20.2419 7.05547 20.2148 6.98899 20.1606L4.08864 17.2601C3.9981 17.1634 3.97683 17.0577 4.02524 16.9428C4.07362 16.822 4.16429 16.7616 4.29712 16.7616H6.03737V4.29C6.03737 4.20549 6.06464 4.13597 6.11889 4.08152C6.17321 4.02714 6.24283 4 6.32737 4H8.06762C8.15229 4 8.22172 4.02727 8.27613 4.08156C8.33055 4.13587 8.35766 4.20549 8.35766 4.29003V16.7616ZM12.1283 6.32029H14.4485C14.5331 6.32029 14.6026 6.29314 14.6568 6.23876C14.7114 6.18435 14.7382 6.11492 14.7382 6.03029V4.29003C14.7382 4.20549 14.7113 4.13597 14.6568 4.08156C14.6026 4.02727 14.5331 4 14.4485 4H12.1283C12.0436 4 11.9742 4.02714 11.9198 4.08152C11.8655 4.13597 11.8383 4.20549 11.8383 4.29V6.03025C11.8383 6.11489 11.8654 6.18432 11.9198 6.23873C11.9742 6.29302 12.0436 6.32029 12.1283 6.32029ZM12.1282 10.961H16.1887C16.2733 10.961 16.3428 10.9338 16.397 10.8794C16.4515 10.825 16.4787 10.7556 16.4787 10.6709V8.93073C16.4787 8.84606 16.4515 8.77663 16.397 8.72225C16.3428 8.66794 16.2733 8.64067 16.1887 8.64067H12.1282C12.0435 8.64067 11.9741 8.66781 11.9197 8.72225C11.8654 8.77663 11.8382 8.84606 11.8382 8.93073V10.6709C11.8382 10.7556 11.8653 10.825 11.9197 10.8794C11.9741 10.9337 12.0435 10.961 12.1282 10.961ZM19.8777 18.0035C19.8232 17.9489 19.7538 17.9218 19.6692 17.9218H12.1283C12.0436 17.9218 11.9742 17.9489 11.9198 18.0035C11.8655 18.0578 11.8383 18.1273 11.8383 18.2118V19.952C11.8383 20.0369 11.8654 20.1061 11.9198 20.1606C11.9742 20.2149 12.0436 20.2421 12.1283 20.2421H19.6692C19.7538 20.2421 19.8232 20.2149 19.8777 20.1606C19.932 20.106 19.9591 20.0369 19.9591 19.952V18.2118C19.9592 18.1273 19.932 18.0578 19.8777 18.0035ZM17.929 15.6014H12.1282C12.0435 15.6014 11.9741 15.5743 11.9197 15.52C11.8653 15.4657 11.8382 15.3961 11.8382 15.3116V13.5712C11.8382 13.4867 11.8654 13.4172 11.9197 13.3629C11.9741 13.3085 12.0435 13.2814 12.1282 13.2814H17.929C18.0135 13.2814 18.083 13.3085 18.1376 13.3629C18.1918 13.4171 18.2189 13.4867 18.2189 13.5712V15.3116C18.2189 15.3961 18.1918 15.4657 18.1376 15.52C18.0831 15.5743 18.0135 15.6014 17.929 15.6014Z"
                        fill="#003448"
                      />
                    </svg>
                    <div>
                      <button type="button" className="hoverFilter linkBtn btn btn-link-theme">
                        {t('Sort By')}
                      </button>
                      <div className="notification sort-by-noti">
                        <div className="arrows"></div>
                        <div className="noumenon">
                          <span>{t('Sort By')} </span>
                          <SortTypeSelect value={sortType} setValue={setSortType} sortOption={sortOption}></SortTypeSelect>
                          <div className="btn-box">
                            <button
                              type="button"
                              style={{ float: 'right' }}
                              className="ApplyBtn btn btn-outline-next"
                              onClick={init}
                            >
                              {t('Apply')}
                            </button>
                            <button
                              type="button"
                              style={{ float: 'right' }}
                              className="ResetBtn btn btn-outline-theme"
                              onClick={() => {
                                setSortType(sortOption[0]);
                                setSearchHandle(!searchhandle);
                              }}
                            >
                              {t('Reset')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" container table-body">
                <div className="row"><SelectedFilters data={filterData} resetFilter={resetFilter} removeFilter={removeFilter} /></div>
                <div class="card clientCard client-card-header">
                  <div class="card-body">
                    <div className="row">
                      <div className="col-sm-1">{t('Client Name')}</div>
                      <div className="col-sm-1">{t('Client ID')}</div>
                      <div className="col-sm-1">{t('Region')}</div>
                      <div className="col-sm-1">{t('Email')}</div>
                      <div className="col-sm-2">{t('Mobile Phone')}</div>
                      <div className="col-sm-1">{t('Language')}</div>
                      <div className="col-sm-2">{t('Total client holdings(USD,CAD)')}</div>
                      <div className="col-sm-2">{t('TotalDistribution')}</div>
                      <div className="col-sm-1"></div>
                    </div>
                  </div>
                </div>

                {listData.map((item, index) => {
                  return (
                    <>
                      <div
                        class={
                          listData[index].show
                            ? 'recordzoomin card clientCard'
                            : 'recordzoomout card clientCard'
                        }
                      >
                        <div class="card-body">
                          <div className="row" style={{ paddingTop: '5px' }}>
                            <div className="col-sm-1">{item.fullName}</div>
                            <div className="col-sm-1">{item.clientID}</div>
                            <div className="col-sm-1">{item.region || 'N/A'}</div>
                            <div className="col-sm-1">{item.email}</div>
                            <div className="col-sm-2">{item.cellularphone || 'N/A'}</div>
                            <div className="col-sm-1">{item.primaryLanguage}</div>
                            <div className="col-sm-2">{(window.localStorage.lang === 'en_US' || window.localStorage.lang === 'jp') ? item.totalClientHoldings : item.totalClientHoldings.replace('CAD', t('CAD1')).replace('USD', t('USD1'))}</div>
                            <div className="col-sm-2">{(window.localStorage.lang === 'en_US' || window.localStorage.lang === 'jp') ? item.totalDistribution : item.totalDistribution.replace('CAD', t('CAD1')).replace('USD', t('USD1'))}</div>
                            <div className="col-sm-1 flex row "
                              style={{ justifyContent: 'center' }}
                            >

                              {item.booklet && item.booklet != null ? (
                                <div style={{ width: '20%', marginRight: '10px' }} onClick={() => {
                                  // window.open(item.booklet);
                                  if (user.sfUserType == 'CL') {
                                    downloadFile('/appUser/booklet', user.bookletFileName)
                                  } else {
                                    downloadFile(`/businessPartner/client/${item.clientID}/booklet`, user.bookletFileName, item.clientID)
                                  }
                                }}>
                                  <Tooltip title="download booklet">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      className="download download-booklet"
                                    >
                                      <path
                                        d="M20.7325 5.72761L16.2371 1.24162C16.169 1.16816 16.087 1.10898 15.9959 1.0675C15.9048 1.02602 15.8064 1.00308 15.7063 1H5.2518C4.6546 1 4.08186 1.23759 3.65958 1.6605C3.2373 2.08341 3.00006 2.65699 3.00006 3.25508V21.2796C2.99573 21.8736 3.22556 22.4452 3.63964 22.8705C4.05371 23.2957 4.61859 23.5402 5.21159 23.5508H18.706C19.0017 23.5508 19.2945 23.4925 19.5677 23.3791C19.8409 23.2658 20.0891 23.0997 20.2982 22.8903C20.5073 22.6809 20.6731 22.4323 20.7863 22.1587C20.8995 21.8851 20.9577 21.5918 20.9577 21.2957V6.25916C20.9557 6.05915 20.8748 5.86805 20.7325 5.72761ZM16.4542 3.57723L18.3923 5.5021H16.4542V3.57723ZM18.706 22.0367H5.21159C5.01324 22.0367 4.82301 21.9577 4.68275 21.8173C4.54249 21.6768 4.46369 21.4863 4.46369 21.2876V3.27119C4.46369 3.07254 4.54249 2.88202 4.68275 2.74156C4.82301 2.60109 5.01324 2.52218 5.21159 2.52218H14.9584V6.25916C14.9584 6.45781 15.0372 6.64833 15.1775 6.78879C15.3177 6.92926 15.508 7.00817 15.7063 7.00817H19.4539V21.2796C19.4549 21.3786 19.4364 21.4769 19.3993 21.5687C19.3621 21.6605 19.3072 21.744 19.2377 21.8144C19.1681 21.8848 19.0853 21.9407 18.994 21.9789C18.9028 22.017 18.8049 22.0367 18.706 22.0367Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M9.71519 9.26364H14.2026C14.4009 9.26364 14.5912 9.18473 14.7314 9.04426C14.8717 8.9038 14.9505 8.71328 14.9505 8.51463C14.9505 8.31598 14.8717 8.12547 14.7314 7.985C14.5912 7.84454 14.4009 7.76562 14.2026 7.76562H9.71519C9.51683 7.76562 9.3266 7.84454 9.18634 7.985C9.04608 8.12547 8.96729 8.31598 8.96729 8.51463C8.96729 8.71328 9.04608 8.9038 9.18634 9.04426C9.3266 9.18473 9.51683 9.26364 9.71519 9.26364Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M9.71519 13.8496H14.2026C14.4009 13.8496 14.5912 13.7707 14.7314 13.6302C14.8717 13.4897 14.9505 13.2992 14.9505 13.1006C14.9505 12.9019 14.8717 12.7114 14.7314 12.5709C14.5912 12.4305 14.4009 12.3516 14.2026 12.3516H9.71519C9.51683 12.3516 9.3266 12.4305 9.18634 12.5709C9.04608 12.7114 8.96729 12.9019 8.96729 13.1006C8.96729 13.2992 9.04608 13.4897 9.18634 13.6302C9.3266 13.7707 9.51683 13.8496 9.71519 13.8496Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M9.71519 18.4238H14.2026C14.4009 18.4238 14.5912 18.3449 14.7314 18.2044C14.8717 18.064 14.9505 17.8734 14.9505 17.6748C14.9505 17.4761 14.8717 17.2856 14.7314 17.1452C14.5912 17.0047 14.4009 16.9258 14.2026 16.9258H9.71519C9.51683 16.9258 9.3266 17.0047 9.18634 17.1452C9.04608 17.2856 8.96729 17.4761 8.96729 17.6748C8.96729 17.8734 9.04608 18.064 9.18634 18.2044C9.3266 18.3449 9.51683 18.4238 9.71519 18.4238Z"
                                        fill="#003448"
                                      />
                                    </svg>
                                  </Tooltip>
                                </div>
                              ) : (
                                <></>
                              )}
                              {item.statement && item.statement != null ? (
                                <div style={{ width: '20%' }} onClick={() => {
                                  if (user.sfUserType == 'CL') {
                                    downloadFile('/appUser/statement', user.statementFileName)
                                  } else {
                                    downloadFile(`/businessPartner/client/${item.clientID}/statement`, user.statementFileName, item.clientID)
                                  }
                                  // window.open(item.statement);
                                }}>
                                  <Tooltip title="download statement">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      className="download download-statement"
                                    >
                                      <path
                                        d="M11.9015 16.051H14.5216C14.9458 16.051 15.2951 15.7017 15.2951 15.2775C15.2951 14.8533 14.9458 14.5039 14.5216 14.5039H11.9015C11.4773 14.5039 11.1279 14.8533 11.1279 15.2775C11.1279 15.7266 11.4773 16.051 11.9015 16.051Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M11.9015 12.0041H14.5216C14.9458 12.0041 15.2951 11.6548 15.2951 11.2306C15.2951 10.8064 14.9458 10.457 14.5216 10.457H11.9015C11.4773 10.457 11.1279 10.8064 11.1279 11.2306C11.1279 11.6548 11.4773 12.0041 11.9015 12.0041Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M11.9015 7.93772H14.5216C14.9458 7.93772 15.2951 7.58838 15.2951 7.16417C15.2951 6.73997 14.9458 6.39062 14.5216 6.39062H11.9015C11.4773 6.39062 11.1279 6.73997 11.1279 7.16417C11.1279 7.61333 11.4773 7.93772 11.9015 7.93772Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M20.7848 2H3.66687C1.84529 2 0.373047 3.47224 0.373047 5.29382V21.214C0.373047 21.4885 0.522766 21.738 0.747345 21.8877C0.996877 22.0125 1.27136 22.0125 1.52089 21.8877L3.99126 20.4404L6.46163 21.8877C6.71116 22.0374 6.98565 22.0374 7.23518 21.8877L9.70555 20.4404L12.1759 21.8877C12.3007 21.9626 12.4254 21.9875 12.5502 21.9875C12.675 21.9875 12.8247 21.9626 12.9245 21.8877L15.3949 20.4404L17.8652 21.8877C18.0898 22.0374 18.3893 22.0374 18.6388 21.8877C18.8883 21.7629 19.0131 21.4885 19.0131 21.214V12.0062H23.33C23.7542 12.0062 24.1036 11.6569 24.1036 11.2327V5.29382C24.0786 3.47224 22.6064 2 20.7848 2ZM17.466 5.29382V19.8665L15.7692 18.8684C15.5196 18.7187 15.2452 18.7187 14.9956 18.8684L12.5253 20.3157L10.0549 18.8684C9.80536 18.7187 9.53088 18.7187 9.28134 18.8684L6.81098 20.3157L4.34061 18.8684C4.21584 18.7935 4.09108 18.7686 3.96631 18.7686C3.84154 18.7686 3.69182 18.7935 3.59201 18.8684L1.89519 19.8665V5.29382C1.89519 4.32065 2.6937 3.52215 3.66687 3.52215H17.99C17.6656 4.02121 17.466 4.64504 17.466 5.29382ZM22.5565 10.4841H19.0131V5.29382C19.0131 4.32065 19.8116 3.52215 20.7848 3.52215C21.758 3.52215 22.5565 4.32065 22.5565 5.29382V10.4841Z"
                                        fill="#003448"
                                      />
                                      <path
                                        d="M6.711 11.9334H7.35978C7.93371 11.9334 8.40782 12.4325 8.33296 13.0314C8.28305 13.5304 7.80894 13.9047 7.28492 13.9047H6.41156C6.08717 13.9047 5.81268 13.6802 5.73782 13.3558C5.71287 13.2809 5.63801 13.2061 5.56315 13.2061H4.56502C4.46521 13.2061 4.3654 13.3059 4.3654 13.4057C4.46521 14.4038 5.28867 15.1774 6.28679 15.2522V16.2503C6.28679 16.3502 6.38661 16.45 6.48642 16.45H7.4596C7.55941 16.45 7.65922 16.3751 7.65922 16.2503V15.2273C8.70726 15.0526 9.58062 14.2291 9.68043 13.1312C9.8052 11.7338 8.70726 10.5361 7.33483 10.5361H6.58623C6.01231 10.5361 5.5382 10.037 5.61306 9.43812C5.66296 8.93906 6.13708 8.56476 6.66109 8.56476H7.53446C7.85885 8.56476 8.13333 8.78934 8.20819 9.11373C8.23315 9.18859 8.308 9.26345 8.38286 9.26345H9.38099C9.48081 9.26345 9.58062 9.16364 9.58062 9.06382C9.48081 8.06569 8.65735 7.29214 7.65922 7.21729V6.21916C7.65922 6.11934 7.55941 6.01953 7.4596 6.01953H6.48642C6.38661 6.01953 6.28679 6.11934 6.28679 6.21916V7.21729C5.06409 7.39196 4.11586 8.4899 4.26558 9.78747C4.3654 11.0351 5.48829 11.9334 6.711 11.9334Z"
                                        fill="#003448"
                                      />
                                    </svg>
                                  </Tooltip>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div
                                style={{ width: '20%', cursor: 'pointer' }}
                                onClick={() => goDetail(item.clientID, item.fullName)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M9 5L15.5333 12.3043L9 19"
                                    stroke="#003448"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Pagination
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    pageSize={pageSize}
                    pageSizeOptions={[10, 20, 50, 100]}
                    onChange={(page, pageSize) => {
                      setPageNum(page);
                      // setPageSize(pageSize);
                    }}
                    onShowSizeChange={(current, size) => {
                      setPageSize(size);
                    }}
                    showTotal={(total) => `${t("Total")} ${total} ${t("items")}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </>)
      }
    </>
  );
};
export default SelectRole;
